export enum ImageCategoryType {
  CustomCampaign = 0,
  Logo = 1,
  Banner = 2,
  TeamMemberPhoto = 3,
  TeamMemberLibrary = 4,
  HealthTopic = 5,
  SocialMedia = 6,
  SocialMediaHidden = 7
}